export const contest = {
    qjy: "İşleme Git",
    grbm: "Bireysel Kayıt",
    qdl: "Giriş Yap",
    bsyjs: "Yarışma Sona Erdi",
    bsjs: "Yarışma Sonu",
    djs: "Simülasyon Ticaret Yarışması {v1} Kalan Süre (Gerisayım)",
    days: "Gün",
    hours: "Saat",
    minutes: "Dakika",
    seconds: "Saniye",
    ljyq: "Hemen Davet Et",
    tdbm: "Takım Kaydı",
    qzc: "Kayıt Ol",
    qrsfgrbm: "Bireysel yarışmaya katılmak istediğinizi onaylıyor musunuz?",
    qxbm: "Kaydı İptal Et",
    qrbm: "Kaydı Onayla",
    gxnbmcg: "Tebrikler, kaydınız başarılı. 100.000 USDT simülasyon parası alacaksınız",
    xzjs: "Olmak istediğiniz rolü seçin",
    cwty: "Takım Üyesi Ol",
    cwtz: "Takım Lideri Ol",
    cjtd: "Takım Oluştur",
    jtgz: "Takım Oluşturma Kuralları:",
    jtgz1: "1. Takım oluşturulduktan sonra 24 saat içinde 5 kişiye ulaşılmazsa takım otomatik olarak dağıtılır ve üyeler otomatik olarak bireysel simülasyon yarışmasına kaydedilir",
    jtgz2: "2. Takım oluşumunu beklerken bireysel simülasyon yarışmasına kaydolamazsınız",
    jtgz3: "3. Takım oluşturulduktan sonra başka bir takıma katılamaz veya bireysel simülasyon yarışmasına giremezsiniz",
    tdmc: "Takım Adı:",
    tdjj: "Takım Tanıtımı:",
    ljjt: "Hemen Takım Kur",
    tdmcbt: "Lütfen takım adını girin",
    tdjzbt: "Lütfen takım tanıtımını girin",
    cjzdcg: "Takım başarıyla oluşturuldu!",
    xzjrtd: "Katılmak istediğiniz takımı seçin",
    sstdmc: "Takım adını ara",
    dqzdsl: "Mevcut takım sayısı: {v1}, Katılmak istediğiniz takımı seçin",
    ddtdrs: "Mevcut takım üye sayısı: {v1} kişi",
    tdrs: "Takım Üye Sayısı:",
    tzmc: "Takım Lideri Adı:",
    jrtd: "Takıma Katıl",
    jrzdcg: "Takıma başarıyla katıldınız!",
    grfxlj: "Kişisel Paylaşım Bağlantısı:",
    grtjm: "Kişisel Referans Kodu:",
    tdfxlj: "Takım Paylaşım Bağlantısı:",
    tdtjm: "Takım Referans Kodu:",
    tdtzm: "Takım Kaptanı İsmi:",
    bctp: "Resmi Kaydet",
    total: "Toplam {v1} kayıt",
    dd: "Şuraya git",
    qd: "Onayla",
    cyyj: "Katılım Ödüllü",
    jcdnn: "USDT ödül havuzu sizi bekliyor!",
    jzcj: "Kârı Bağışla, Çekilişe Katıl",
    dqjc: "Mevcut ödül havuzu:",
    qjz: "Bağış Yap",
    jzsm: "Bağış Açıklaması",
    kjz: "Şu anda {v1} USDT hayır fonuna bağış yapabilirsiniz, bağışlamak istediğinizi onaylıyor musunuz?",
    qxjz: "Bağışı İptal Et",
    qrjz: "Bağışı Onayla",
    jzcg: "Tebrikler, bağışınız başarılı!",
    mnpjyds: "Simülasyon Ticaret Yarışması",
    bm: "Kayıt:",
    bs: "Yarışma:",
    hyspjyds: "Vadeli İşlem Yarışması ",
    xhspjyds: "Spot İşlem Yarışması",
    bmz: "Kayıt Devam Ediyor",
    jqqd: "Yakında",
    bsz: "Yarışma Devam Ediyor",
    yjs: "Sona Erdi",
    myptts: "Simülasyon Takım Yarışması ",
    mypzmxs: "Haftanın Yıldızları Yarışması",
    mypgrs: "Simülasyon Bireysel Yarışma",
    hyjyds: "Vadeli İşlem Yarışması ",
    xhjyds: "Spot İşlem Yarışması",
    my: "Benim",
    pm: "Sıralama",
    dync: "Üye Rumuzu",
    dm: "Takım Adı",
    zdrs: "Takım Üye Sayısı",
    nc: "Rumuz",
    ljzjy: "Toplam İşlem",
    ljzjye: "Toplam İşlem Hacmi",
    ljzyll: "Toplam Kârlılık Oranı",
    zyll: "Toplam Kârlılık Oranı",
    zdjl: "Takım Ödülü",
    mypbsjl: "Katılım Ödüllü",
    myphycs: "Simülasyon Vadeli İşlem Yarışmasına Katıl",
    myhyj: "Kayıt başarılı olursa 100.000U simülasyon vadeli işlem parası alırsınız",
    ljbm: "Hemen Katıl",
    tzjl: "Takım Kurma Ödülü",
    ztcg: "5 kişi ile takım kurulur, 200 kişi ile sınırlıdır",
    bwzbhl: "Takım lideri takım kurduğunda 100.000U+ kazanabilir",
    yqjl: "Davet Ödülü",
    yqhycybs: "Takım lideri davet ederse, en fazla 100.000U kazanır",
    hzhyj: "Takım üyesi davet ederse, en fazla 50.000U kazanır",
    mnttbssm: "Simülasyon Takım Yarışması Kuralları Açıklaması",
    csxq: "Katılım Detayları:",
    csxq1: "1. Etkinlik kayıt başlangıç tarihinden - yarışma bitiş tarihine kadar kullanıcılar (kimlik doğrulaması yapıldıktan sonra) istedikleri zaman takım kurabilirler; vadeli işlem takım yarışması için takım üye sayısı ≥ 5 kişi; ≤200 kişi olmalıdır; takım kurulduktan sonra 24 saat içinde 5 kişiye ulaşılmazsa, takım otomatik olarak dağıtılır ve takım üyeleri otomatik olarak bireysel yarışma bölgesine kaydedilir.",
    csxq2: "2. Kullanıcılar sadece bir takım seçebilir ve katılabilir, tekrarlı katılım yapamaz, aynı anda takım ve bireysel yarışmaya katılamaz, kullanıcılar takıma katıldıktan sonra takımdan çıkamaz",
    ssgz: "Yarışma Kuralları:",
    ssgz1: "1. Takım Lideri Avantajları: 1) Takım lideri davet ettiği her üye için 1000USDT simülasyon parası kazanır, davet ödülü 100.000USDT ile sınırlıdır;",
    ssgz1_2: "          2) Takım lideri 20'den fazla arkadaşını davet edip işlem yaptırırsa Biking özel hediyelik eşya seti kazanır.",
    ssgz2: "2. Takım Üyesi Avantajları: Takım üyesi davet ettiği her arkadaş için 500USDT simülasyon vadeli işlem parası kazanır, davet ödülü 50.000USDT ile sınırlıdır",
    ssgz3: "3. Takım yarışması sonunda platform, takımın gerçek toplam işlem hacmini nihai sıralama kriteri olarak alacaktır",
    ssgz4: "4. Simülasyon Takım Yarışması toplam işlem hacmi her gün 00:00'da güncellenecektir",
    ssgz5: "5. Yarışma sonuçlarının adil olması için lütfen hileli işlem yapmayın, hileli işlem veya sahte işlem verisi tespit edilirse biking müşteri hizmetleri ekibi müdahale edecektir. Simülasyon Takım Yarışması toplam işlem hacmi her gün 00:00'da güncellenecektir",
    ssgz6: "6. Detaylı etkinlik kuralları için biking müşteri hizmetleri ekibi ile iletişime geçin.",
    jlfp: "Ödül Dağıtımı:",
    jlfp1: "1. USDT ödül dağılımı: (Ödüller dağıtılırken, simülasyon vadeli işlem fonu ile nakit ödeme her zaman 9:1 oranında dağıtılır)",
    jlfp1_1: "1) Takım içi dağıtım oranı:",
    jlfp1_2: "Takım lideri ödülü = Takım lideri kişisel toplam vadeli işlem hacmi / Biking Simülasyon Takım Yarışması toplam işlem hacmi * 5.000.000 USDT",
    jlfp1_3: "+ Takımdaki diğer üyelerin toplam performansı / Biking Simülasyon Takım Yarışması toplam işlem hacmi * %20 * 5.000.000 USDT.",
    jlfp1_4: "Takım üyesi ödülü = Mevcut kullanıcı toplam vadeli işlem hacmi / Biking Simülasyon Takım Yarışması toplam işlem hacmi * %80 * 5.000.000 USDT.",
    jlfp1_5: "2) Yarışma sırasında performansı yüksek olan takımlar kolektif kazanç artışından faydalanabilir! Kazanç artış oranı, takım üye sayısı ve takım toplam işlem hacmine göre belirlenir, takım üye sayısı/toplam işlem hacmi her ikiye katlandığında %50 hesaplama gücü artışı elde edilir",
    myptdjyze: "Simülasyon Takım Yarışması Toplam İşlem Hacmi",
    myptdphb: "Simülasyon Takım Yarışması Sıralaması",
    tdsl: "Mevcut takım sayısı: {v1}, Katılmak istediğiniz takımı seçin",
    tznc: "Takım Lideri Rumuzu:",
    tdjs: "Takım Tanıtımı:",
    mypzmxgzsm: "Simülasyon Haftanın Yıldızları Yarışması Kuralları Açıklaması",
    zmxphb: "Haftanın Yıldızları Takım Sıralaması (Sadece ilk üç)",
    zmxtdphb: "Haftanın Yıldızları Takım Sıralaması",
    bdxq: "Sıralama Detayları:",
    bdxq1: "1. Takım başarıyla kurulup işleme başlandığında otomatik olarak Haftanın Yıldızları takım sıralamasına katılmış sayılırsınız",
    zmxgz: "1. Sistem her doğal haftayı bir dönem olarak alacak ve mevcut takımları toplam işlem hacmine göre sıralayarak 'Haftanın Yıldızları Takım Sıralaması'nı yayınlayacaktır, ilk 3 sıradaki takımlar 2.000.000 USDT vadeli işlem simülasyon parası ödülünü paylaşacaktır",
    zmxgz1: "2. Haftanın Yıldızları takım sıralaması her Çarşamba 14:00'te güncellenir",
    bddym: "Sıralama birincisi 1.000.000 USDT simülasyon vadeli işlem parası kazanır;",
    dbdem: "İkinci 600.000 USDT simülasyon vadeli işlem parası kazanır;",
    bddsm: "Üçüncü 400.000 USDT simülasyon vadeli işlem parası kazanır;",
    tdnbfpgz: "Takım içi dağıtım kuralları:",
    tzx: "Takım Lideri: %20;",
    nbyjpm: "Takım içi performans sıralamasında ilk 10'daki üyeler (takım lideri hariç): %40'ı paylaşır",
    syty: "Kalan üyeler: %40",
    mypgrsgzsm: "Simülasyon Bireysel Yarışma Kuralları Açıklaması",
    mypgrphb: "Simülasyon Bireysel Yarışma Sıralaması",
    bsxz: "Yarışma Bilgileri:",
    bsxz1: "1. Her yeni kullanıcı yarışmaya kaydolarak 100.000 USDT simülasyon vadeli işlem parası alır",
    bsxz2: "2. Mevcut kullanıcılar yarışmaya kaydolarak 50.000 USDT simülasyon vadeli işlem parası alır",
    bsxz3: "2. Yarışma sırasında kullanıcılar arkadaşlarını davet ederek ek deneme parası kazanabilir:",
    bsxz4: "1) Kullanıcı davet ettiği her arkadaş için 2.000 USDT simülasyon deneme parası kazanır;",
    bsxz6: "2) Davet ödülü en fazla 50.000 USDT simülasyon vadeli işlem parası ile sınırlıdır",
    bsxz7: "3. Bu yarışma sadece Biking borsasında kimliği doğrulanmış kullanıcılara açıktır.",
    bsxz8: "4. Yarışma sonunda, katılımcıların nihai toplam işlem hacmi bireysel yarışma sıralama kriteri olarak alınacaktır.",
    grgzsm1: "1. Toplam ödül havuzu: 2.000.000 USDT + 30 adet özel hediyelik eşya",
    grgzsm2: "2. Dağıtım detayları:",
    grgzsm3: "Birinci: 800.000 USDT + 5 adet özel hediyelik eşya",
    grgzsm4: "İkinci: 500.000 USDT + 5 adet özel hediyelik eşya",
    grgzsm5: "Üçüncü: 200.000 USDT + 3 adet özel hediyelik eşya",
    grgzsm6: "Dördüncü - Yirminci: 500.000 USDT + 17 adet özel hediyelik eşya paylaşılır",
    hyjybs: "Vadeli İşlem Yarışması",
    hyjybsgzsm: "Vadeli İşlem Yarışması Kuralları Açıklaması",
    hyspgrphb: "Vadeli İşlem Yarışması Bireysel Sıralaması",
    csxz: "Katılım Bilgileri:",
    hybsgz1: "1. Vadeli işlem yarışmasına kaydolarak 100 USDT değerinde vadeli işlem özel fonu kazanırsınız (özel fon kullanım kuralları için platform şartlarına bakın), bu özel fondan elde edilen kâr, yarışma süresince hesabın toplam kârlılık oranına dahil edilmez.",
    hybsgz2: "2. Kullanıcılar arkadaşlarını vadeli işlem yarışmasına davet edebilir, başarıyla davet edilen her arkadaş için 20 USDT vadeli işlem özel fon ödülü alınır, davet ödülü上限ı 100 USDT'dir.",
    hybsgz3: "3. Bu yarışma sadece Biking borsasında kimliği doğrulanmış kullanıcılara açıktır.",
    hybsgz4: "4. Yarışma sonunda sistem, yarışma süresince kullanıcıların toplam kârlılık oranını sıralama kriteri olarak alacaktır.",
    jcfp: "Ödül Havuzu Dağılımı:",
    jcfp1: "Toplam ödül havuzu: 2.000.000 USDT + 30 adet özel hediyelik eşya",
    fpgz: "Dağıtım Kuralları:",
    fpgzs: "(Ödüller dağıtılırken, vadeli işlem özel fonu ile nakit ödeme her zaman 9:1 oranında dağıtılır)",
    fpgz1: "Birinci: 800.000 USDT + 5 adet özel hediyelik eşya",
    fpgz2: "İkinci: 500.000 USDT + 5 adet özel hediyelik eşya",
    fpgz3: "Üçüncü: 200.000 USDT + 3 adet özel hediyelik eşya",
    fpgz4: "Dördüncü - Yirminci: 500.000 USDT + 17 adet özel hediyelik eşya paylaşılır",
    hjyq: "Kazanma Şartları",
    hjyq1: "1. Vadeli işlem yarışması kârı = Hesap nihai net değeri (gerçekleşmemiş kâr/zarar dahil) - Hesap başlangıç net değeri (gerçekleşmemiş kâr/zarar dahil) - Yarışma vadeli işlem bonusu.",
    hjyq2: "2. Kâr miktarı aynı olan kullanıcılarda, işlem hacmi daha yüksek olan kazanır.",
    hjyq3: "3. Ödül kazanan kullanıcıların hesap kârının 0'dan büyük olması gerekir.",
    gyc1: "Bu ödül havuzu sadece vadeli işlem yarışması ve spot yarışması katılımcılarına açıktır, kullanıcılar yarışmayı erken bitirip mevcut işlem hacmi/kârlılık oranını hayır havuzuna bağışlayabilir.",
    gyc2: "Sistem her kâr yüzdesi*0.5USDT oranında hayır havuzuna bağış yapar, havuz bakiyesi yarışma sayfasında gösterilir",
    gyc3: "Örneğin, A kullanıcısının gerçek kârlılık oranı %38 ise, bağış yaptığında sisteme 38*0.5=19USDT hayır fonu (hayır ödülü vadeli işlem özel fonudur) yatırılır.",
    gyc4: "Hayır havuzu toplam limit: 50.000 USDT vadeli işlem özel fonu",
    gyc5: "Kullanıcı işlem hacmini bağışlarken, sistem her 100USDT işlem hacmi=0.5USDT hayır fonu oranında hayır havuzuna bağış yapar, örn: B kullanıcısı toplam 1000USDT işlem hacmi ile 0.5USDT*10=5USDT hayır havuzuna bağış yapar (hayır ödülü vadeli işlem özel fonudur)",
    gyc7: "Bağış Bilgileri: Her kullanıcı sadece bir kez hayır bağışında bulunabilir, bağış yapıldığında, kullanıcı tüm biking yarışması sıralama, ödül kazanma ve katılım haklarından vazgeçmiş sayılır (vadeli işlem yarışması katılımcıları hayır bağışı yaptıktan sonra spot yarışmasına katılamaz).",
    gyc8: "Yarışma sonunda, hayır ödül havuzu üç çekilişe açılacak, her çekilişte 10 kişi ödülü paylaşacak, üç çekiliş ödül dağılım oranı: %40, %30, %30.",
    gyc9: "Çekiliş zamanı: Yarışma bitiminden sonra 7 iş günü içinde rastgele yapılacaktır. Detaylar için resmi çalışanlara danışın.",
    xhjybs: "Spot İşlem Yarışması",
    xhjybsgzsm: "Spot İşlem Yarışması Kuralları Açıklaması",
    xhjydsphb: "Spot İşlem Yarışması Sıralaması",
    grbmcg: "Bireysel kayıt başarılı!",
    xhgz1: "1. Spot işlem yarışması platformdaki tüm spot işlem çiftlerini içerir",
    xhgz2: "2. Katılımcıların platform spot hesap bakiyesinin 50 USDT'den fazla olması gerekir",
    xhgz3: "3. Yarışma sonunda, platform kullanıcıların spot toplam işlem hacmini sıralama kriteri olarak alacaktır",
    jjfp: "Ödül Dağılımı",
    zjc: "Toplam ödül havuzu: 1.000.000 USDT + 20 adet özel hediyelik eşya",
    xhdym: "Birinci: 400.000 USDT + 10 adet hediyelik eşya",
    xhdem: "İkinci: 200.000 USDT + 5 adet hediyelik eşya",
    xhdsm: "Üçüncü: 100.000 USDT + 5 adet hediyelik eşya",
    xhdsm1: "Dördüncü - Yirminci: 300.000 USDT paylaşılır",
    mypdnpm: "Simülasyon Takım İçi Sıralaması",
    yqjl1: "Davet Ödülü",
    wdjye: "Benim İşlem Hacmim:",
    wdzsyl: "Benim Toplam Kârlılık Oranım:",
    grzjyl: "Simülasyon Bireysel Toplam İşlem Hacmi:",
    grzsyl: "Simülasyon Bireysel Toplam Kârlılık Oranı:",
    sqzjye: "Simülasyon Yarışma Toplam İşlem Hacmi:",
    zjye: "Yarışma Toplam İşlem Hacmi:",
    bsyqrs: "Yarışma Davet Edilen Kişi Sayısı:",
    ren: "kişi",
    hdmnj: "Kazanılan Simülasyon Parası:",
    hdzj: "Kazanılan Bonus:",
    hyjyxq: "Vadeli İşlem Yarışması Detayları",
    xhjyxq: "Spot İşlem Yarışması Detayları",
    hy: "Vadeli İşlem",
    xh: "Spot",
    jlsm: "Ödül Açıklaması:",
    jlsm1: "1. Yarışma süresince kullanıcılar (kimlik doğrulaması yapıldıktan sonra) istedikleri zaman takım kurabilir; vadeli işlem takım yarışması için takım üye sayısı ≥ 5 kişi; ≤200 kişi olmalıdır; takım kurulduktan sonra 24 saat içinde 5 kişiye ulaşılmazsa, takım otomatik olarak dağıtılır.",
    jlsm2: "2. Herkes sadece bir takıma katılabilir, tekrarlı katılım yapılamaz ve takımdan çıkılamaz",
    tdjye: "Takım İşlem Hacmi:",
    wdjs: "Benim Rolüm:",
    dz: "Takım Lideri",
    dy: "Takım Üyesi",
    tdzyll: "Takım Toplam Kârlılık Oranı:",
    wdzyll: "Benim Toplam Kârlılık Oranı:",
    tdyjhdjl: "Takımın Tahmini Ödülü:",
    tdjs1: "Takım Tanıtımı",
    grxq: "Kişisel Detaylar",
    tdxq: "Takım Detayları",
    tdjylpm: "Takım İşlem Hacmi Sıralaması:",
    tdzsyl: "Takım Toplam Kârlılık Oranı",
    tdnphb: "Takım İçi Sıralama",
    tcsybs: "İpucu: Bağış yapmak tüm yarışmalardan çıkış anlamına gelir",
    zwcjhybs: "Henüz simülasyon vadeli işlem yarışmasına katılmadınız",
    zwsj: "Henüz veri yok",
    tdmcbzq: "Takım adı formatı hatalı",
    tdjjbzq: "Takım tanıtım formatı hatalı",
    hdjxz_contract: "Sürekli Vadeli İşlem Yarışması devam ediyor, yarışmaya katılın 2.000.000U ödül havuzundan pay alın ve özel Biking hediyeleri kazanın",
    hdjxz_spot: "Spot İşlem Yarışması devam ediyor, yarışmaya katılın 1.000.000U ödül havuzundan pay alın ve özel Biking hediyeleri kazanın",
    hdjs: "Sonraki yarışmayı bekleyin"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/tr.js